import { Outlet } from 'react-router';
import { RegisterProvider } from '@/features/login/registration';

const withRegisterProvider = WrappedComponent => {
  const Wrapped = ({ id, scheme, ...rest }) => (
    <RegisterProvider id={id} scheme={scheme}>
      <WrappedComponent {...rest} />
    </RegisterProvider>
  );

  return Wrapped;
};

export const RegisterLayout = withRegisterProvider(() => {
  return <Outlet />;
});
